import { render, staticRenderFns } from "./DriverTable.vue?vue&type=template&id=058f852f&"
import script from "./DriverTable.vue?vue&type=script&lang=js&"
export * from "./DriverTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports